import { func, number } from 'prop-types';
import React from 'react';
import { GoTrashcan } from 'react-icons/go';
import { Button } from 'reactstrap';

import withConfirm from '../../generic/with-confirm';

const DeleteWithConfirmation = withConfirm(
  'Do you really want to delete this creative, and withdraw it from all campaign lines it is assigned to?',
)(Button);

export default function DeleteButton({ id, onDeleteCreative }) {
  return (
    <DeleteWithConfirmation
      outline
      size="sm"
      onClick={() => onDeleteCreative(id)}
      data-qa-field="deleteBtn"
    >
      <GoTrashcan />
    </DeleteWithConfirmation>
  );
}

DeleteButton.propTypes = {
  id: number.isRequired,
  onDeleteCreative: func.isRequired,
};
